import { NgForOf } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import {citizenRouteNames} from '../../../pages/citizen/citizen.routes';

interface MenuLink  {
  href: string;
  label: string
}

@Component({
  selector: "app-mb-menu-links",
  templateUrl: "./mb-menu-links.component.html",
  imports: [
    FormsModule,
    NzIconModule,
    NzSelectModule,
    NzInputModule,
    NzFormModule,
    RouterLink,
    RouterLinkActive,
    NgForOf,
  ]
})
export class MBMenuLinksComponent{
  private transloco = inject(TranslocoService);

  menuLinks: MenuLink[] = [
    {
     label: this.transloco.translate("home"),
     href: citizenRouteNames.index
    },
    {
     label: this.transloco.translate("myDashboard"),
     href: citizenRouteNames.complaints
    },
]
}
